import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import { BRAND_TILE_WIDTH } from '../storeConnections.utils';

interface BrandTileProps {
  label: string;
  onClick: () => void;
  children: ReactNode;
  testId?: string;
}

const BrandTile = ({ label, onClick, children, testId }: BrandTileProps) => (
  <Stack
    component="button"
    type="button"
    spacing={1.5}
    useFlexGap
    test-id={testId}
    onClick={onClick}
    sx={(theme) => ({
      width: BRAND_TILE_WIDTH,
      flexShrink: 0,
      alignItems: 'center',
      px: 0.5,
      py: 1,
      border: 'none',
      cursor: 'pointer',
      borderRadius: `${theme.shape.borderRadiusLg}px`,
      backgroundColor: 'transparent',
      '&:hover': { backgroundColor: 'action.hover' },
    })}
  >
    {children}
    <Typography
      variant="body1"
      component="span"
      color="text.primary"
      noWrap
      sx={{ maxWidth: '100%' }}
    >
      {label}
    </Typography>
  </Stack>
);

export default BrandTile;
